module.exports = __webpack_public_path__ + "static/img/MODUL.92f1e65e.png";